module.exports = __webpack_public_path__ + "static/media/circle-grey.5dd950ec.svg";